import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import {matchMedia} from '../../core/browser'
import Box from '../../core/components/Box'
import Markdown from '../../core/components/Markdown'
import TicketClaimCountCard from '../../claim/components/TicketClaimCountCard'
import config from '../../config'
import i18n from '../i18n'
import TicketStream from './TicketStream'
import TicketStats from './TicketStats'
import SimplifiedRequestCountCardWrap from './SimplifiedRequestCountCardWrap'
import OpenTicketModal from './OpenTicketModal'
import style from './TicketStreamLayout.less'

class TicketStreamLayout extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, authenticated} = this.props

        const newTicketBoxTitle = (
            <h3>{i18n.newTicket}</h3>
        )

        const welcomeBoxHelp = config.resource.welcome && config.resource.welcome.url && (
            <img src={config.resource.welcome.url} />
        )

        return (
            <div>
                <Row>
                    <Col sm={4} smPush={8}>
                        <TicketStats stacked />
                        {matchMedia('sm') && config.resource.welcome && config.resource.welcome.text && (
                            <Box
                                help={welcomeBoxHelp}>
                                <div className={style.welcome}>
                                    <Markdown markdown={config.resource.welcome.text} />
                                </div>
                            </Box>
                        )}
                        <TicketClaimCountCard />
                        <SimplifiedRequestCountCardWrap />
                    </Col>
                    <Col sm={8} smPull={4}>
                        <TicketStream />
                    </Col>
                </Row>
                <OpenTicketModal />
            </div>
        )
    }
}

export default TicketStreamLayout


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketStreamLayout.js